import { createReducer } from '@reduxjs/toolkit';

import { loadHintsStart, loadHintsSuccess } from './actions';
import { IHintListData, IHintsReducer } from './types';

const initialState: IHintsReducer = {
  isLoading: false,
  isLoaded: false,
  data: {} as IHintListData,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(loadHintsStart, (state) => ({ ...state, isLoading: true }))
    .addCase(loadHintsSuccess, (state, action) => ({ ...state, isLoading: false, isLoaded: true, data: action.payload }));
});
